function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m63.187 59.424-15.888-15.888a26.66 26.66 0 1 0-3.7637 3.7637l15.888 15.888a2.6618 2.6618 0 1 0 3.7637-3.7637zm-36.485-11.427a21.294 21.294 0 1 1 21.294-21.294 21.294 21.294 0 0 1-21.294 21.294z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6618
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.236eb17f.svg";
export { ForwardRef as ReactComponent };